const src = "https://dnnqo5iczq5wf.cloudfront.net/asset/lottie/6ffa728b26";
export default src;
